import React, { useEffect } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs/dist/grapes.min.js';
import './styles/editor.css'
import webPlugin from 'grapesjs-preset-webpage';
import basicPlugin from 'grapesjs-blocks-basic';
import flexbox from 'grapesjs-blocks-flexbox';
import axios from 'axios';
import formPlugin from 'grapesjs-plugin-forms';
import gradient from 'grapesjs-style-gradient';
import bgStyles from 'grapesjs-style-bg';
import tooltip from 'grapesjs-tooltip';
import customcode from 'grapesjs-custom-code';
import parserPostCSS from 'grapesjs-parser-postcss';
import typed from 'grapesjs-typed';
import tabs from 'grapesjs-tabs';
import pluginCountdown from 'grapesjs-component-countdown';
// import grapejsRulers from 'grapesjs-rulers';

function applyReadOnlyToComponents(editor) {
    if (!editor) return
    try {
        const wrapper = typeof editor.getWrapper === 'function' ? editor.getWrapper() : null
        if (!wrapper) return
        const walk = (cmp) => {
            if (!cmp) return
            cmp.set({
                selectable: false,
                hoverable: false,
                draggable: false,
                droppable: false,
                removable: false,
                copyable: false,
                highlightable: false,
                badgable: false,
                stylable: false,
                editable: false,
                layerable: false,
                resizable: false,
            })
            cmp.components()?.forEach((child) => walk(child))
        }
        walk(wrapper)
        const selected = [...(editor.getSelectedAll?.() || [])]
        selected.forEach((c) => editor.selectRemove?.(c))
    } catch {
        /* editor destroyed or canvas not ready */
    }
}

const CustomGrapeEditor = ({ setEditor, editor, currentPage, currentReport, readOnly }) => {
    useEffect(() => {
        const tmpEditor = grapesjs.init({
            container: '#gjs',
            height: '1024px',
            width: '100%',
            plugins: [webPlugin, basicPlugin, flexbox, formPlugin, bgStyles, gradient, tooltip, pluginCountdown, customcode, parserPostCSS, typed, tabs],
            fromElement: true,
            // storageManager: {
            //     id: 'gjs-',
            //     type: 'local',
            //     autosave: true,
            //     autoload: true,
            //     storeComponents: true,
            //     storeStyles: true,
            //     storeHtml: true,
            //     storeCss: true,
            // },
            storageManager: false,
            assetManager: readOnly ? false : {
                upload: `${process.env.REACT_APP_NODE_API_URL}/survey/uploadReportImage`,
                uploadName: 'reportImg',
                multiUpload: false,
                customFetch: (url, options) => {
                    return axios(url, {
                        method: 'POST',
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token_id')}`
                        },
                        data: options.body,
                        params: {
                            page: currentPage?.id,
                            report: currentReport
                        }
                    })
                },
            },
            pluginsOpts: {
                [webPlugin]: {
                    blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video', 'map'],
                },
                [gradient]: {},
                [bgStyles]: {}
            },
        })

        tmpEditor.StyleManager.addProperty('decorations', {
            type: 'gradient',
            name: 'Gradient',
            property: 'background-image',
            defaults: 'none',
            full: true,
        });

        tmpEditor.StyleManager.addProperty('decorations', {
            extend: 'background-image',
            name: 'Gradient Background',
        })

        tmpEditor.on('asset:upload:response', (response) => {
            const image = response?.data?.data
            if (image) {
                tmpEditor.AssetManager.add({ src: image })
            }
        })

        tmpEditor.on('load', () => {
            const fontProperty = tmpEditor.StyleManager.getProperty('typography', 'font-family')
            fontProperty.set('list', [])
            const list = [
                fontProperty.addOption({ value: 'Vodafone, Arial, sans-serif', name: 'Vodafone Font' }),
            ]
            fontProperty.set('list', list)
            if (readOnly) {
                applyReadOnlyToComponents(tmpEditor)
            }
        })

        setEditor(tmpEditor)

        return () => {
            tmpEditor.destroy()
            setEditor(null)
        }
    }, [currentPage, currentReport, setEditor, readOnly])

    useEffect(() => {
        if (!editor || !readOnly) return undefined
        const apply = () => applyReadOnlyToComponents(editor)
        apply()
        const timers = [40, 120, 400].map((ms) => setTimeout(apply, ms))
        const onFrameLoad = () => apply()
        editor.on('canvas:frame:load', onFrameLoad)
        editor.on('load', onFrameLoad)
        return () => {
            timers.forEach(clearTimeout)
            try {
                editor.off('canvas:frame:load', onFrameLoad)
                editor.off('load', onFrameLoad)
            } catch {
                /* editor may already be destroyed */
            }
        }
    }, [editor, readOnly, currentPage])


    return (
        <>
            <div id="gjs" key={currentPage?.id}>

            </div>
        </>
    )
}

export default CustomGrapeEditor